import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import Locked from "../../assets/imgs/secured.svg";
import InvitationPassword from "../InvitationPassword";
import { useLocation, useNavigate } from "react-router-dom";

const LockedInvitation = ({ errorMessage }: { errorMessage: string }) => {
	const [passCode, setPassCode] = useState<string[]>(new Array(6).fill(""));
	const location = useLocation();
	const navigate = useNavigate();
	const isWrong = errorMessage.includes("Wrong");

	useEffect(() => {
		const isValid = passCode.every(p => Number(p));
		if (isValid) {
			navigate(`${location.pathname}?password=${passCode.join("")}`);
		}
	}, [passCode]);

	return (
		<Box
			className={"invitation-wrapper"}
			display={"flex"}
			justifyContent={"center"}
			alignItems={"center"}
			flexDirection={"column"}
		>
			<img src={Locked} alt="Invitation locked" width={250} />
			<Box mt={4} display={"flex"} flexDirection={"column"} alignItems={"center"}>
				<Typography variant={"h6"} fontWeight={"bold"}>
					{isWrong ? "Wrong password" : "Invitation is locked"}
				</Typography>
				<Typography variant={"subtitle2"} color={"textSecondary"}>
					Please enter passcode to get invitation access
				</Typography>
			</Box>
			<InvitationPassword passCode={passCode} setPassCode={setPassCode} />
		</Box>
	);
};

export default LockedInvitation;
